import React from "react"
import styled from "@emotion/styled"

export default class Footer extends React.PureComponent {
  render() {
    const {twitter_code, footerText} = this.props.footerContext;
    return (
      <Wrapper className="section footer">
      <div className="section_inner">
        <p dangerouslySetInnerHTML={{
          __html: footerText.string.replace(`2019`, `Yay Okay LLC ${new Date().getFullYear()}`)
        }} />
        <div className="fb-like" data-href="http://yaytext.com" data-layout="standard" data-action="like" data-size="small" data-show-faces="true" data-share="false"></div><br/>
        <a className="twitter-follow-button" href="https://twitter.com/yaytext" lang={twitter_code}>Follow @YayText</a><br/>
        <div className="fb-page" data-href="https://www.facebook.com/yaytext" data-small-header="true" data-adapt-container-width="true" data-hide-cover="true" data-show-facepile="true"><blockquote cite="https://www.facebook.com/yaytext" className="fb-xfbml-parse-ignore"><a href="https://www.facebook.com/yaytext">YayText</a></blockquote></div>
      </div>
    </Wrapper>
    )
  }
}

const Wrapper = styled("div")`
p {font-size: 14px; margin: 0 0 1em;}
a {color: inherit;}
`
